export class ProductionLogIdRequest{
    productionLogId:number;
    opBoxes?:number;
    outputQuantity?:number
    constructor(productionLogId:number,opBoxes?:number,outputQuantity?:number){
        this.productionLogId = productionLogId;
        this.opBoxes=opBoxes;
        this.outputQuantity=outputQuantity
    }
}